// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","inner":"Footer_inner__CVEiR","text":"Footer_text__27sON","links":"Footer_links__wMgLO"};